import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

export const columns = [
  {
    id: 'name',
    disablePadding: false,
    label: i18n.t('vehicles.fullName'),
  },
  {
    id: 'lastKnownLocation',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastKnownLocation'),
  },
  {
    id: 'unitName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.unit'),
  },
  {
    id: 'driveTimeRemaining',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.driveTimeRemaining'),
  },
  {
    id: 'timeUntilBreak',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.timeUntilBreak'),
  },
  {
    id: 'onDutyTimeRemaining',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.onDutyTimeRemaining'),
  },
  {
    id: 'dutyCycleRemaining',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.dutyCycleRemaining'),
  },
  {
    id: 'currentStatus',
    disablePadding: false,
    needSorting: window?.$environment?.CURRENT_LAYOUT === 'SpireonNew' ? false : false,
    label: i18n.t('dashboard.tabs.driverStatus.currentStatus'),
  },
  ...(checkServiceProvider('config_engineSpeed', window.$environment.SERVICE_PROVIDER, false)
    ? [
        {
          id: 'engineSpeed',
          numeric: false,
          disablePadding: false,
          label: i18n.t('dashboard.tabs.driverStatus.engineSpeed'),
        },
      ]
    : []),
  {
    id: 'lastUpdated',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastUpdated'),
  },
  ...(checkServiceProvider('config_columns', window.$environment.SERVICE_PROVIDER, false) || []),
];

export const overRideColumns = [
  { id: 'name', disablePadding: false, label: i18n.t('Driver Name') },
  {
    id: 'unitName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.unit'),
  },
  {
    id: 'driveTimeRemaining',
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.driveTime'),
  },
  {
    id: 'onDutyTimeRemaining',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.onDutyTime'),
  },
  {
    id: 'dutyCycleRemaining',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.dutyCycleRemaining'),
  },
  {
    id: 'lastKnownLocation',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastKnownLocation'),
  },
  {
    id: 'lastUpdated',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.lastUpdated'),
  },
  ...(checkServiceProvider('override_columns', window.$environment.SERVICE_PROVIDER, false) || []),
];

export const getELDStatusIcon = (status) => {
  const statusMap = {
    NOT_STARTED: 'eld-inActive',
    TAMPERED: 'eld-inActive',
    DISCONNECTED: 'eld-inActive',
    CONNECTED: 'eld-active',
    '': 'eld-loggedOut',
  };

  return statusMap[status] || '';
};
